import { Box, Grid, Stack, Typography } from '@mui/material';

import { FormCard } from '@/components';
import { colors } from '@/theme/variables';

import { FormItemRoot } from '../styles';

export const CFSMap = () => {
  return (
    <FormCard classes={{ cardContent: 'map-card-content' }}>
      <FormItemRoot>
        <Stack spacing={2}>
          <Box
            style={{ height: 342, borderRadius: 8, background: '#E7EAEC' }}
          ></Box>
          <Box className="map-details-wrapper">
            <Grid container columnSpacing={2}>
              <Grid item xs={6}>
                <Typography
                  sx={{ fontSize: '0.75rem', color: colors.grey[80] }}
                >
                  Cross streets
                </Typography>
                <Typography className="map-item-value">
                  Oak Street and Pine Avenue
                </Typography>
              </Grid>
            </Grid>
          </Box>
        </Stack>
      </FormItemRoot>
    </FormCard>
  );
};
